'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  user-select: none;\n  cursor: pointer;\n  border-radius: ', ';\n'], ['\n  user-select: none;\n  cursor: pointer;\n  border-radius: ', ';\n']);

var _StyledCard = require('./StyledCard');

var _StyledCard2 = _interopRequireDefault(_StyledCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledTrigger = _StyledCard2.default.extend(_templateObject, function (props) {
  return props.open ? '6px 6px 0 0 !important' : '6px';
});

StyledTrigger.displayName = 'StyledTrigger';

exports.default = StyledTrigger;
//# sourceMappingURL=StyledTrigger.js.map


//////////////////
// WEBPACK FOOTER
// ../card-drawer/lib/StyledTrigger.js
// module id = 153
// module chunks = 0